export default function FormatStrikethroughIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 18}
      height={height ? height : width ? width : 18}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M110 649.391q-12.75 0-21.375-8.675T80 619.216q0-12.825 8.625-21.325t21.375-8.5h740q12.75 0 21.375 8.676 8.625 8.675 8.625 21.5 0 12.824-8.625 21.324-8.625 8.5-21.375 8.5H110Zm310.391-120V362.218H250q-24.837 0-42.223-17.421-17.386-17.42-17.386-42.306 0-24.886 17.386-42.189T250 242.999h460q24.837 0 42.223 17.421 17.386 17.42 17.386 42.306 0 24.886-17.386 42.189T710 362.218H539.609v167.173H420.391Zm59.491 379.61q-24.886 0-42.189-17.386-17.302-17.386-17.302-42.224v-140h119.218v140q0 24.791-17.42 42.2-17.42 17.41-42.307 17.41Z"
      />
    </svg>
  );
}
